import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthAppService } from '@app/@auth/shared/auth-app.service';
import { User } from '@app/@auth/shared/user.model';
import { AlertService } from '@app/@core/services';
import * as CryptoJS from 'crypto-js';
import { DxFormComponent } from 'devextreme-angular';

@Component({
  templateUrl: './app-login.page.html',
  styleUrls: ['./app-login.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLoginPage implements OnInit, AfterViewInit {
  user: User;
  submitted = false;
  // iframeSrc: SafeUrl;
  loadingVisible = false;
  url = '';
  app = '';
  // @ViewChild('iframe') iframe!: ElementRef;
  @ViewChild(DxFormComponent) loginForm!: DxFormComponent;

  constructor(
    private authAppService: AuthAppService,
    private alertService: AlertService,
    private sanitizer: DomSanitizer,
    private datepipe: DatePipe,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
    this.user = new User(0, '', '', '', new Date(), '', 0, 0);
    // this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
    //   'https://auth.ekisa.com.co/'
    // );

    this.onEnterKeyUsuario = this.onEnterKeyUsuario.bind(this);
    this.onEnterKeyPassword = this.onEnterKeyPassword.bind(this);
  }
  ngAfterViewInit(): void {
    this.loginForm?.instance.getEditor('usuario')?.focus();
  }

  get secretKey(): string {
    return `110132076987${this.datepipe.transform(new Date(), 'yyyyMMddHH')}`;
  }

  ngOnInit(): void {}

  async onSubmit() {
    this.loadingVisible = true;
    this.submitted = true;
    const { isValid } = this.loginForm.instance.validate();
    if (isValid) {
      this.authAppService
        .login(this.user.usuario, this.user.password)
        .subscribe((response) => {
          if (response && response.usuario && response.urlAplicacion) {
            if (response.usuario && response.estado === 'Activo') {
              if (response.urlAplicacion) {
                const userName = this.encrypt(this.user.usuario);
                const password = this.encrypt(this.user.password);
                const credentials = [`x=${userName}`, `y=${password}`].join(
                  '&',
                );
                this.url = `${response.urlAplicacion}/login?${credentials}&fromExternalSource=1`;
                window.location.href = this.url;
                // this.iframe.nativeElement.src = this.url;

                //  window.location.href = `${response.urlAplicacion}/login?${credentials}&fromExternalSource=1`;
              }
            } else if (response.estado !== 'Activo') {
              this.alertService.showWarning(
                'El usuario o el cliente asociado no se encuentran activos. Por favor, comuníquese con el administrador.',
                4000,
                'top center',
                'top center',
              );
              this.loadingVisible = false;
            }
          } else {
            this.alertService.showError(
              'Usuario o contraseña incorrecto.',
              4000,
              'top center',
              'top center',
            );
            this.loadingVisible = false;
          }
        });
    }
  }

  onEnterKeyUsuario(e) {
    this.loginForm.instance.getEditor('password')?.focus();
  }
  onEnterKeyPassword(e) {
    this.onSubmit();
  }
  changeApp(app: string) {
    this.app = app;
  }

  private encrypt(value: string) {
    return CryptoJS.AES.encrypt(value, this.secretKey)
      .toString()
      .replace(/\+/g, '258$');
  }

  // async onLoad(iframe) {
  //   await new Promise((f) => setTimeout(f, 1000));
  //   if (iframe.src === this.url) {
  //     window.location.href = this.url;
  //   }
  //   this.loadingVisible = false;
  // }
}
